const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      login: {
        title: "Login",
        form: {
          email: "Email",
          password: "Senha",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
      },
      dashboard: {
        charts: {
          perDay: {
            title: "Tickets hoje: ",
          },
        },
        messages: {
          inAttendance: {
            title: "Em Atendimento"
          },
          waiting: {
            title: "Aguardando"
          },
          closed: {
            title: "Finalizado"
          }
        },
        titulo: "Dashboard",
        summaryBanner: "Exibindo dados de {{from}} a {{to}} para {{userName}}",
        filters: {
          title: "Filtros",
          show: "Mostrar filtros",
          hide: "Ocultar filtros"
        }
      },
      connections: {
        outboundPause: {
          chip: "ENVIOS PAUSADOS",
          switchLabel: "Envios de saída",
          active: "Ativos",
          paused: "PAUSADOS",
          pausedHelp: "Nenhuma mensagem sai por esta conexão: nem do chat, nem da IA, nem modelos, nem lembretes. Ficam no chat marcadas como não enviadas.",
          confirmTitle: "Pausar os envios de {{name}}?",
          confirmMessage: "Enquanto estiver pausada, NENHUMA mensagem sairá por esta conexão: respostas do chat, da IA, modelos, confirmações e lembretes de agendamentos. As mensagens recebidas continuam chegando. Lembre-se de retomá-la.",
          confirmButton: "Pausar envios",
          toastPaused: "Envios de {{name}} PAUSADOS.",
          toastResumed: "Envios de {{name}} retomados.",
        },
        title: "Conexões",
        empty: "Ainda não há conexões.",
        toasts: {
          deleted: "Conexão com o WhatsApp excluída com sucesso!",
          restarted: "Conexão reiniciada com sucesso",
          newDefault: "{{name}} agora é sua conexão padrão.",
        },
        defaultChanged: {
          message: "Sua conexão padrão mudou para {{name}}. Se quiser outra, altere aqui.",
          change: "Alterar",
          ack: "Entendi",
        },
        metaHealth: {
          checking: "Verificando status…",
          refresh: "Atualizar status",
          blockingChip: "Impede o envio",
          blockingNote: "Isso impede que seu número envie mensagens até você resolver.",
          nonBlockingNote: "Não impede o funcionamento, mas vale a pena resolver.",
          ok: { title: "Conexão ativa", desc: "Seu número Meta está pronto para enviar e receber." },
          billing_missing: { title: "Falta configurar o pagamento", desc: "Seu número NÃO PODE enviar mensagens até você configurar um método de pagamento na Meta. Isso é o que está bloqueando o envio agora.", descDetected: "Detectamos que a Meta rejeitou um envio por falta de método de pagamento. Se você já adicionou um cartão, tente enviar novamente; se continuar falhando, confira a Central de Faturamento.", action: "Configurar pagamento" },
          payment_unverified: { title: "Não conseguimos verificar o método de pagamento", desc: "Ainda não confirmamos um envio bem-sucedido com este número. Se um envio falhar, pode ser porque falta um cartão cadastrado na Meta.", action: "Verificar pagamento" },
          register_needed: { title: "Falta ativar o número", desc: "Seu número está verificado mas ainda não está ativado para enviar. Podemos ativá-lo aqui.", action: "Repetir registro", retrying: "Ativando…", retryOk: "Número ativado. Atualizando status…", retryFail: "Não foi possível ativar o número. Tente novamente em instantes." },
          pending: { title: "A Meta está revisando seu número", desc: "A Meta ainda está verificando seu número. Pode demorar um pouco; não há nada a fazer do seu lado por enquanto." },
          name_declined: { title: "Nome recusado", desc: "A Meta recusou o nome visível do número. Isso NÃO bloqueia o envio nem o recebimento de mensagens; vale a pena trocá-lo mesmo assim para melhorar a entrega: na tela do número, vá em Perfil → Nome de exibição.", action: "Alterar nome" },
          quality_low: { title: "Qualidade do número baixa", desc: "A Meta baixou a qualidade do seu número. Você ainda pode enviar e receber, mas modere o ritmo de envios para não perder a habilitação." },
          no_templates: { title: "Sem modelos aprovados", desc: "Você não tem modelos aprovados. Ainda pode responder normalmente dentro de 24 horas, mas precisa de um modelo para iniciar conversas novas fora dessa janela.", action: "Criar modelo" },
          check_failed: { title: "Não foi possível verificar", desc: "Não conseguimos consultar o status na Meta agora. Tente atualizar em instantes." },
          qualityChip: "Qualidade: {{quality}}",
          quality: { GREEN: "Alta", YELLOW: "Média", RED: "Baixa" },
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
          disconnectMessageMeta: "Tem certeza de que deseja desconectar esta conexão Meta?",
          restartTitle: "Reiniciar conexão",
          restartMessage: "Reiniciar a conexão? Todos os dados e configurações serão preservados. A conexão será reconectada e mostrará um novo QR Code.",
          restartMessageMeta: "Tentar novamente a conexão? Todos os dados e configurações serão preservados. A conexão Meta será restabelecida.",
        },
        buttons: {
          add: "Adicionar WhatsApp",
          disconnect: "desconectar",
          tryAgain: "Tentar novamente",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          connecting: "Conectando",
          restart: "Reiniciar",
          templates: "Modelos",
          edit: "Editar",
          delete: "Excluir",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          disconnectedMeta: {
            title: "A conexão Meta não está ativa",
            content:
              "A conexão Meta não está ativa. Clique em 'Tentar novamente' para restabelecê-la.",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
        },
        table: {
          name: "Nome",
          number: "Número",
          type: "Tipo",
          status: "Status",
          backup: "Reserva",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
        },
        badges: {
          primary: "PRIMÁRIA",
          standby: "RESERVA",
          failover: "FAILOVER ATIVO",
        },
        types: {
          qrPro: "WhatsApp QR — Pro",
          qrWeb: "WhatsApp QR — Web",
          metaCloud: "Meta Cloud API",
          coexistence: "Meta Coexistence",
          qrProDesc: "Estável e eficiente. A opção recomendada para a maioria.",
          qrWebDesc: "Máxima compatibilidade com todos os dispositivos.",
          metaCloudDesc: "Conexão oficial certificada pela Meta. Modelos e mensagens em massa.",
          coexistenceDesc: "Use o WhatsApp do seu celular e o WAIA ao mesmo tempo.",
          notEnabled: "Não habilitado",
        },
        alerts: {
          primaryDown: "A conexão {{name}} foi desconectada. Verifique a página de conexões.",
          primaryDownWithStandby: "A conexão {{name}} foi desconectada. Usando reserva {{standby}} automaticamente.",
          standbyDown: "A reserva {{name}} não está disponível. Apenas a conexão principal permanece.",
          primaryDownBothFailed: "A conexão {{name}} e sua reserva {{standby}} estão desconectadas.",
        },
        stepSelectType: "Que tipo de conexão você quer adicionar?",
        stepConfigure: "Configuração",
        noTypesEnabled: "Nenhum tipo de conexão habilitado para esta empresa. Contate o administrador.",
        backupConnection: "Conexão reserva",
        noBackup: "Sem reserva",
        backupOf: "Reserva de:",
        unlinkBackup: "Desvincular",
        allowedConnectionTypes: "Tipos de conexão permitidos",
      },
      connectionBanner: {
        pausedPrefix: "ENVIOS PAUSADOS em",
        pausedSuffix: "Nenhuma mensagem sai por essa conexão.",
        prefix: "A conexão WhatsApp",
        statusDisconnected: "está desconectada",
        statusWaitingQr: "está aguardando QR",
        actionQr: "Escaneie o QR para reconectar.",
        actionMeta: "Tente reconectar.",
        goToConnections: "Ir para conexões →",
      },
      whatsappModal: {
        title: {
          add: "Adicionar WhatsApp",
          edit: "Editar WhatsApp",
        },
        form: {
          name: "Nome",
          default: "Padrão",
          farewellMessage: "Mensagem de despedida",
          n8nWebhookUrl: "Webhook n8n desta conexão (opcional)",
          n8nWebhookUrlHelp: "Se preenchido, as mensagens que chegam por esta linha são enviadas para este webhook (um bot dedicado por linha). Vazio = usa o webhook da empresa.",
          backupConnection: "Conexão reserva",
          noBackup: "Sem reserva",
          backupOf: "Esta conexão é reserva de:",
          unlinkBackup: "Desvincular",
          isPrimary: "Esta conexão é a primária",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          next: "Próximo",
        },
        success: "WhatsApp salvo com sucesso.",
        meta: {
          phoneNumberId: "Phone Number ID",
          wabaId: "WABA ID",
          appId: "App ID",
          accessToken: "Access Token",
          whereToFind: "Encontre em Meta Business → WhatsApp → Configuração de API",
          updateToken: "Atualizar token",
          tokenHidden: "Token salvo ●●●●●●●●",
        },
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      contacts: {
        title: "Contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os tickets relacionados serão perdidos.",
          importMessage: "Deseja importas todos os contatos do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          actions: "Ações",
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
        },
        form: {
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do Whatsapp",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Valor",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      quickAnswersModal: {
        title: {
          add: "Adicionar Resposta Rápida",
          edit: "Editar Resposta Rápida",
        },
        form: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Resposta Rápida salva com sucesso.",
      },
      queueModal: {
        title: {
          add: "Adicionar fila",
          edit: "Editar fila",
        },
        form: {
          name: "Nome",
          color: "Cor",
          greetingMessage: "Mensagem de saudação",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
      },
      userModal: {
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          canSeeUnassigned: "Ver chats não atribuídos",
          allowedWhatsapps: "Conexões permitidas",
          allowedWhatsappsAll: "Todas as conexões",
          allowedWhatsappsHelp: "Se não selecionar nenhuma, o usuário verá os chats de todas as conexões.",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Usuário salvo com sucesso.",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
      },
      ticketsManager: {
        buttons: {
          newTicket: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        noAccess: "Você não tem acesso a este chat.",
        toasts: {
          deleted: "O ticket que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Inbox" },
          closed: { title: "Resolvidos" },
          deleted: { title: "Excluídos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar tickets e mensagens",
        },
        buttons: {
          showAll: "Todos",
        },
        selectQueueModal: {
          title: "De qual departamento você quer atender?",
          subtitle: "O ticket será atribuído a este departamento",
          confirm: "Confirmar",
          cancel: "Cancelar",
        },
        selectWhatsappModal: {
          title: "De qual conexão enviar?",
          subtitle: "Selecione a conexão do WhatsApp",
          confirm: "Confirmar",
          cancel: "Cancelar",
        },
        acceptedSuccess: "Ticket atendido com sucesso",
      },
      transferTicketModal: {
        title: "Transferir conversa",
        fieldUser: "Atribuir a usuário (opcional)",
        fieldUserPlaceholder: "Buscar usuário...",
        fieldQueue: "Departamento",
        fieldQueuePlaceholder: "Selecionar departamento...",
        fieldConnection: "Conexão",
        fieldNote: "Nota interna (opcional)",
        fieldNotePlaceholder: "Escreva um comentário para o agente que recebe o chat. Use / para inserir respostas rápidas.",
        fieldNoteHelper: "Esta nota será visível apenas para os agentes no chat.",
        userNoQueueInfo: "Este usuário não tem departamento atribuído. A conversa será transferida sem departamento.",
        transferButton: "Transferir",
        cancelButton: "Cancelar",
        disabledTooltip: "Selecione um usuário ou departamento para continuar",
        successToast: "Conversa transferida",
        noOptions: "Nenhum usuário encontrado com esse nome",
        noteHeader: {
          title: "🔄 Transferência",
          fromTo: "De: {{from}} → {{to}}",
          toQueue: "Departamento {{queue}}",
        },
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        pendingHeader: "Aguardando",
        // feat_340: el CHIP del zócalo (no el tab).
        pendingChipLabel: "Não lido",
        assignedHeader: "Atendendo",
        pendingHeaderShort: "Espera",
        assignedHeaderShort: "Ativo",
        noTicketsTitle: "Nada aqui!",
        filters: {
          all: "Todos",
          unassigned: "Não atribuídos",
          none: "Filtros",
          tags: "Etiquetas",
          filtersLabel: "Filtros:",
          tagPlaceholder: "Etiqueta",
          tagCount: "{{count}} etiquetas",
          tagCountOne: "1 etiqueta",
          contactTypes: "Tipo de Cliente",
          contactTypePlaceholder: "Tipo",
          contactTypeCount: "Tipo: {{count}} selecionados",
          contactTypeCountOne: "1 tipo selecionado",
          queuePlaceholder: "Departamento",
          queueCount: "{{count}} departamentos",
          statePlaceholder: "Estado",
          userPlaceholder: "Usuário",
          userCount: "{{count}} usuários",
          userUnassigned: "Sem atribuição",
        },
        noQueue: "Sem departamento",
        noTicketsMessage:
          "Nenhum ticket encontrado com esse status ou termo pesquisado",
        connectionTitle: "Conexão que está sendo utilizada atualmente.",
        contactsWithoutChat: "Contatos sem chat",
        startChat: "Iniciar chat",
        group: "Grupo",
        buttons: {
          accept: "Aceitar",
        },
        deletedView: {
          restoreBtn: "Restaurar",
          restoreOne: "Restaurar este chat",
          hardDeleteBtn: "Excluir definitivamente",
          hardDeleteOne: "Excluir permanentemente",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        toastExisting: "Já havia chat com {{name}} — abrindo o existente",
        toastInOtherQueue: "Chat na fila \"{{queueName}}\" atendido por {{userName}}. Peça uma transferência.",
        otherAgent: "outro atendente",
        inOtherQueueActive: "Este chat está sendo atendido por {{userName}} na fila \"{{queueName}}\". Peça para transferirem para você.",
        inOtherQueueClosed: "Este chat pertence à fila \"{{queueName}}\" e você não tem acesso.",
        toastNoConnection: "Sem conexões WhatsApp ativas disponíveis",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          announcements: "Comunicados",
          connections: "Conexões",
          tickets: "Tickets",
          contacts: "Contatos",
          quickAnswers: "Respostas Rápidas",
          queues: "Filas",
          administration: "Administração",
          users: "Usuários",
          settings: "Configurações",
        },
        appBar: {
          user: {
            profile: "Perfil",
            logout: "Sair",
            darkMode: "Modo escuro",
            density: "Densidade",
            densityCompact: "Compacto",
            densityNormal: "Normal",
            densityComfortable: "Amplo",
          },
        },
        sidebar: {
          pin: "Fixar menu",
          unpin: "Desafixar menu",
        },
      },
      notifications: {
        noTickets: "Nenhuma notificação.",
      },
      queues: {
        title: "Filas",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar fila",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os tickets dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queueSelect: {
        inputLabel: "Filas",
      },
      quickAnswers: {
        title: "Respostas Rápidas",
        table: {
          shortcut: "Atalho",
          message: "Resposta Rápida",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Resposta Rápida",
        },
        toasts: {
          deleted: "Resposta Rápida excluída com sucesso.",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle:
            "Você tem certeza que quer excluir esta Resposta Rápida: ",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
      },
      users: {
        title: "Usuários",
        table: {
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          whatsapp: "Conexão Padrão",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar usuário",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
      },
      companies: {
        secretariaIaSuperadminLabel: "Secretária IA",
        secretariaIaSuperadminHelp: "Habilita a Secretária IA para esta empresa. Se desativada, nenhuma IA responderá.",
        iaAdminCanToggleLabel: "Permitir controle ao administrador",
        iaAdminCanToggleHelp: "Se ativo, o admin desta empresa pode ligar ou desligar a IA pelo seu painel.",
      },
      ia: {
        toolbarActiveTooltip: "IA ligada — clique para desligar",
        toolbarInactiveTooltip: "IA desligada — clique para ligar",
        toolbarTurnosNote: "Apenas Secretária/Vendedor IA: o assistente do TurnosIA tem o seu próprio interruptor (TurnosIA › Configurações).",
        menuSecretariaLabel: "Secretária IA",
        menuVendedorLabel: "Vendedor IA",
        vendedorDisabledTooltip: "Ative primeiro a Secretária IA",
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        businessInfo: {
          title: "Dados do negócio",
          subtitle: "Informações que a IA usa em cada conversa com clientes.",
          address: "Endereço",
          phone: "Telefone",
          whatsapp: "WhatsApp de atendimento",
          email: "Email de contato",
          locationLink: "Link do Google Maps",
          hoursText: "Horários em texto livre",
          hoursTextHelp: "Ex: Seg a Sex das 9 às 18h. Texto que a IA pode ler ao cliente.",
          timezone: "Fuso horário",
        },
        businessHours: {
          title: "Horário comercial",
          always247Label: "Disponível 24/7",
          always247Helper: "Se estiver ativo, a empresa é considerada sempre disponível independentemente do horário configurado.",
          scheduleLabel: "Horário de atendimento",
          scheduleHelper: "Define os dias e horários em que a empresa está disponível para receber consultas. Usado para o carrinho abandonado e outras automações.",
        },
        title: "Configurações",
        secretariaIaSuperadminLabel: "Secretária IA",
        secretariaIaSuperadminHelp: "Habilita a Secretária IA para esta empresa. Se desativada, nenhuma IA responderá.",
        vendedorIaSuperadminLabel: "Vendedor IA",
        vendedorIaSuperadminHelp: "Habilita o Vendedor IA. Requer a Secretária IA ativa.",
        iaAdminCanToggleLabel: "Permitir controle ao administrador",
        iaAdminCanToggleHelp: "Se ativo, o admin da empresa pode ligar ou desligar a IA pelo seu painel.",
        secretariaIaLabel: "Secretária IA",
        aiSilenceOnTicketOpenLabel: "Silenciar IA ao assumir o ticket",
        aiSilenceOnTicketOpenHelp: "Se ativo, quando um atendente assume (abre) um ticket a IA para de responder a esse contato imediatamente, sem esperar o atendente escrever. Ao fechar o ticket a IA é reativada.",
        secretariaIaHelp: "Controla se a Secretária IA responde mensagens recebidas.",
        vendedorIaLabel: "Vendedor IA",
        vendedorIaHelp: "Controla se o Vendedor IA assume contatos qualificados.",
        vendedorIaDisabledTooltip: "Ative primeiro a Secretária IA",
        iaControlSectionTitle: "Inteligência Artificial",
        iaActiveStatus: "Estado atual",
        iaStatusOn: "Ligada",
        iaStatusOff: "Desligada",
        iaScheduleSectionTitle: "Horário automático da IA",
        iaScheduleEnabledLabel: "Ativar IA automaticamente fora do horário",
        iaScheduleEnabledHelp: "A IA será ligada sozinha quando terminar o horário de atendimento. Não desliga automaticamente ao começar o horário.",
        settings: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
        },
      },
      messagesList: {
        forwarded: "Encaminhado",
        unsupportedMessage: "Mensagem não compatível",
        historyMediaUnavailable: "📎 Arquivo do histórico indisponível",
        forwardedMany: "Encaminhado muitas vezes",
        header: {
          assignedTo: "Atribuído à:",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
          },
        },
      },
      messagesInput: {
        placeholderOpen: "Digite uma mensagem ou tecle ''/'' para utilizar as respostas rápidas cadastrada",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        captionPlaceholder: "Adicionar comentário...",
        cancelMedia: "Cancelar",
        sendMedia: "Enviar",
        dropFileHere: "Solte o arquivo aqui",
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
        },
        extraInfo: "Outras informações",
      },
      ticketActionButtons: {
        exportTooltip: "Baixar conversa (TXT)",
      },
      ticketOptionsMenu: {
        delete: "Deletar",
        transfer: "Transferir",
        confirmationModal: {
          title: "Excluir conversa com {{name}}?",
          message: "O chat irá para Excluídos. Você pode restaurá-lo de lá.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      backendErrors: {
        ERR_OUTBOUND_PAUSED: "Os envios desta conexão estão PAUSADOS: a mensagem não foi enviada. Retome em Conexões.",
        ERR_INVALID_PAUSED_VALUE: "Valor inválido para pausar os envios.",
        // feat_299 — "Ver como usuario"
        ERR_VIEW_AS_INVALID_ID: "O usuário indicado para \"Ver como\" não é válido.",
        ERR_VIEW_AS_REQUIRES_ADMIN: "Apenas um administrador pode usar \"Ver como usuário\".",
        ERR_VIEW_AS_USER_NOT_FOUND: "Esse usuário não foi encontrado na sua empresa.",
        ERR_VIEW_AS_INVALID_TARGET: "Você não pode ver como outro administrador.",
        ERR_PINNED_WHATSAPP_DISCONNECTED: "A conexão atribuída a esta conversa está desconectada. Reconecte-a para poder responder.",
        ERR_OPT_IN_REQUIRED: "Você deve confirmar o consentimento dos destinatários.",
        ERR_TEMPLATE_HEADER_VARS_NOT_SUPPORTED: "O modelo tem variáveis fora do corpo (cabeçalho ou botão), não suportadas.",
        ERR_TEMPLATE_HEADER_MEDIA_REQUIRED: "Este modelo leva um arquivo no cabeçalho: anexe o arquivo para poder enviá-lo.",
        ERR_TEMPLATE_HEADER_MEDIA_NOT_SUPPORTED: "Este modelo não aceita anexos: o cabeçalho dele é de texto.",
        ERR_TEMPLATE_HEADER_MEDIA_TYPE_MISMATCH: "O arquivo não corresponde ao tipo de cabeçalho do modelo.",
        ERR_TEMPLATE_HEADER_MEDIA_UPLOAD_FAILED: "Não foi possível enviar o arquivo para a Meta. Tente novamente em alguns minutos.",
        ERR_TEMPLATE_HEADER_SAMPLE_REQUIRED: "Envie um arquivo de amostra: a Meta exige isso para aprovar um modelo com cabeçalho de arquivo.",
        ERR_TEMPLATE_HEADER_SAMPLE_UPLOAD_FAILED: "Não foi possível enviar o arquivo de amostra para a Meta. Tente novamente em alguns minutos.",
        ERR_BULK_IMPORT_IN_PROGRESS: "Já há um envio em massa em andamento para esta empresa.",
        ERR_WHATSAPP_NOT_CONNECTED: "A conexão selecionada não está conectada.",
        ERR_NOT_META_CONNECTION: "A conexão selecionada não é da Meta.",
        ERR_TEMPLATE_NOT_APPROVED: "O modelo não está aprovado pela Meta.",
        ERR_PROFILE_NOT_FOUND: "Perfil de envio não encontrado.",
        ERR_BULK_IMPORT_NOT_FOUND: "Envio em massa não encontrado.",
        ERR_BULK_IMPORT_NOT_CANCELLABLE: "O envio não pode ser cancelado no estado atual.",
        ERR_BULK_IMPORT_NOT_RETRYABLE: "O envio não permite nova tentativa no estado atual.",
        ERR_META_CONSECUTIVE_FAILURES: "O envio foi pausado por falhas consecutivas da Meta.",
        ERR_META_BILLING_MISSING: "Não foi possível enviar: falta o método de pagamento na Meta. Adicione um cartão na Central de Faturamento.",
        ERR_WHATSAPP_NOT_FOUND: "Conexão não encontrada.",
        ERR_TEMPLATE_NOT_FOUND: "Modelo não encontrado.",
        ERR_FILE_REQUIRED: "Arquivo obrigatório.",

        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_TICKET_LOCKED_BY_OTHER_AGENT: "Este ticket está em atendimento por outro atendente. Você não pode escrever.",
        ERR_REQUIRES_SUPER_SUPERADMIN: "Apenas o superadmin principal pode realizar esta ação.",
        ERR_COMPANY_OUT_OF_SCOPE: "Esta empresa não pertence à sua marca.",
        ERR_FEATURE_NOT_ALLOWED: "Você não tem permissão para acessar esta seção.",
        ERR_CANNOT_CHANGE_INSTANCE_ID: "Você não pode mudar a marca de uma empresa fora da sua.",
        ERR_RESELLER_HAS_NO_WHITELABEL: "Este reseller não tem uma marca atribuída.",
        ERR_INVALID_TARGET_COMPANIES: "Você só pode enviar avisos a empresas da sua marca.",
        ERR_TEMPLATE_VARS_MISMATCH: "Faltam exemplos: informe um exemplo para cada variável do template.",
        ERR_TEMPLATE_VARS_SEQUENCE: "As variáveis devem ser sequenciais a partir de {{1}} (sem saltos).",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_META_INVALID_CREDENTIALS:
          "Credenciais Meta inválidas. Verifique o Access Token e o Phone Number ID.",
        ERR_META_WINDOW_EXPIRED:
          "Janela de 24 horas expirada. O cliente deve escrever primeiro.",
        ERR_META_NUMBER_NOT_WA:
          "Este número não possui uma conta WhatsApp ativa.",
        ERR_WHATSAPP_ALREADY_LINKED:
          "Esta conexão já está vinculada a outra. Desvincule primeiro.",
        ERR_META_PHONE_ALREADY_LINKED:
          "Este número da Meta já está conectado em outra empresa. Um mesmo número não pode estar em duas empresas.",
      },
      errors: {
        metaWindowExpired: "⚠️ Janela de 24 horas expirada. O cliente deve escrever primeiro para retomar a conversa, ou use um template para iniciá-la.",
      },
    },
  },
};

export { messages };
